import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowRight, Loader2, AlertCircle } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        login(data.token);
        navigate('/admin');
      } else {
        setError(data.detail || 'Invalid credentials');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }

    setLoading(false);
  };

  return (
    <main className="min-h-screen bg-[#F5F1EC] flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-12">
          <img
            src="https://customer-assets.emergentagent.com/job_aozat-power/artifacts/19tmgxv4_image.png"
            alt="AOZAT"
            className="h-16 w-auto mx-auto mb-4"
          />
          <p 
            className="text-xs tracking-[0.2em] uppercase text-[#5C5855]"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Admin Portal
          </p>
        </div>

        {/* Form */}
        <div className="bg-white p-8 border border-[#E5DFD5]">
          <h1 
            className="text-2xl text-[#3D3A38] text-center mb-8"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Sign In
          </h1>

          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="form-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input-underline"
                placeholder="admin@aozatelectrical.ca"
                data-testid="login-email"
              />
            </div>

            <div>
              <label className="form-label">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input-underline"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full inline-flex items-center justify-center gap-2"
              data-testid="login-submit"
            >
              {loading ? (
                <>
                  <Loader2 size={14} className="animate-spin" />
                  Signing in...
                </>
              ) : (
                <>
                  Sign In <ArrowRight size={14} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
